(function ($, Drupal, once) {

  Drupal.behaviors.stickyHeader = {
    attach: function (context, settings) {

      $(window).scroll(function () {
        if ($(window).width() > 810) {
          var $el = $('.page-header--sticky');
          var $el2 = $('.page-body');
          var scrollPosition = 89; // Header top height

          if ($(this).scrollTop() > scrollPosition) {
            $el.addClass('fix-header'); // Additional class for styling if needed
            $el2.addClass('fix-container'); // Adjust page-body styles if needed
          } else {
            $el.removeClass('fix-header');
            $el2.removeClass('fix-container');
          }
        }
      });
    }
  };

  Drupal.behaviors.burgerMenu = {
    attach: (context, settings) => {
      once('burgerMenu', 'html', context).forEach(() => {
        const burgerMenu = document.querySelector('.js-burgermenu');
        const header = document.querySelector('.page-header');
        if (!burgerMenu) {
          return;
        }
        if (!header) {
          return;
        }

        function checkElementDisplayed(element) {
          const elementDisplay = window.getComputedStyle(element).display;
          return elementDisplay !== 'none';
        }

        let burgerMenuVisible = checkElementDisplayed(burgerMenu);
        window.addEventListener('resize', () => {
          burgerMenuVisible = checkElementDisplayed(burgerMenu);
          header.classList.remove('open');
        });

        function toggleOpen() {
          if (header.classList.contains('open')) {
            header.classList.add('hide');
            setTimeout(() => {
              header.classList.remove('hide');
            }, 300);
          }
          header.classList.toggle('open');
        }

        if (!burgerMenu.hasListener) {
          burgerMenu.addEventListener('click', () => {
            toggleOpen();
          });

          burgerMenu.addEventListener('keydown', (event) => {
            // Check if the key is Enter or Space
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault(); // Prevent the default action for these keys
              toggleOpen();
            }
          });
          burgerMenu.hasListener = true;
        }
      });
    },
  };

  Drupal.behaviors.radixHoverDropdown = {
    attach: function (context, settings) {
      once('radix-hover-dropdown', '.nav-item.dropdown', context).forEach(function (dropdownToggle) {
        const $dropdownToggle = $(dropdownToggle)
        $dropdownToggle.on('mouseenter', function () {
          $dropdownToggle.addClass('show');
          $dropdownToggle.find('.dropdown-menu').addClass('show');
        })

        $dropdownToggle.on('mouseleave', function () {
          $dropdownToggle.removeClass('show')
          $dropdownToggle.find('.dropdown-menu').removeClass('show')
        });

        $dropdownToggle.find('.dropdown-toggle').on('click', function () {
          const $link = $(this)

          const url = $link.attr('href')

          if (isTouchScreen()) {
            if (!$link.attr('data-open')) {
              $link.attr('data-open', 1)
            }
            else {
              window.open(url, '_self')
            }
          }
          else {
            window.open(url, '_self')
          }

          if ($link.parent().hasClass('show')) {
            const url = $link.attr('href')

            if (url) {
            }
          }
        })
      });

      function isTouchScreen() {
        return 'ontouchstart' in window
          || navigator.maxTouchPoints > 0
          || navigator.msMaxTouchPoints > 0
      }
    }
  };
})(jQuery, Drupal, once);
